import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { API_URLS } from '../../common/constants/routes-config';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { MODULE_NAMES, CLIENT, PROPERTIES_TO_BE_CLEANED , LOGIN_QUERYPARAMS, USER_TYPES, SECOND_DELIVERY, ELIGIBLE_USER_SECOND_DELIVERY, ENTERPRISE, MAPPED_SIM_TYPE } from '../../common/constants/defines';
import { Store, select } from '@ngrx/store';
import { OrderDetailsState } from '../../redux/states/orderDetails.state';
import { getorderDetailsState, selectCustomerType, getLogisticsPositionAndReturnsEntitled, getPostalShoppingCustomPositions, getPostalShopping} from '../../redux/selectors/order-details.selectors';
import { Position, PositionStatus, PerviousTransaction, EsimModel, PositionClassification, ReturnsEntitled } from '../../models/position.model';
import { regex } from '../../../config/regex-config';
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import forOwn from 'lodash/forOwn';
import { Logistics } from 'src/app/models/logistics.model';
import { JSON_PATHS } from 'src/app/common/constants/mapping.defines';
import { CustomerTypes, DeliveryStatus, Delivery, DeliveryGroupModel } from 'src/app/models/delivery.model';
import { ShipToContactPoint } from 'src/app/models/shipToContactPoint.model';
import { UserCredentials } from 'src/app/models/userCredential.model';
    // eslint-disable-next-line no-var
declare var jsonpath: any;
import { LOGIN_SUCCESS } from 'src/config/tracking.defines';
import { ShipToParty } from 'src/app/models/shipToParty.model';
import { TRANSACTION_NAMES } from 'src/app/models/transaction-names.model';
import { takeUntil , take , flatMap , map, catchError } from 'rxjs/operators';
import { Subject , of , forkJoin} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PostalShoppingScenarios } from 'src/app/models/postal-shopping.model';
import { UpdatePosition } from 'src/app/redux/actions/order-details.action';
import { SetPostalShoppingCustomPositions } from 'src/app/redux/actions/order-details-extend.actions';
import { UtilsService } from './utils.service';
import { SetTransactionName } from 'src/app/redux/actions/order-details-extend.actions';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/** OrderDetailedService */
@Injectable()
export class OrderDetailedService {
    /** secondDeliveryAllowed */
    public secondDeliveryAllowed: boolean = false;
    /** tariffnameResponse */
    public tariffnameResponse: any;
    /** semicolonCheck filter */
    public semicolonCheck = regex.semicolonCheck;
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    /** customerType */
    public customerType;
    /**
     *
     * @param httpClient
     * @param store
     * @param customError
     * @param ts
     * @param utilsService
     */
    public constructor (private httpClient: HttpClient, private store: Store<OrderDetailsState>, private customError: CustomErrorHandlerService, private ts: TranslateService,
        private utilsService: UtilsService) {
        }

    /**
     * Change the order for the user
     * @param {Delivery} delivery the delivery for the customer
     * @param {CONSULTATION_METHODS} consultationMethod the consultation method which is has been chosen by the user
     * @returns {Observable<CONSULTATION_METHODS>} the observable which holds the response of the back end
     */

    /** changeOrder */
    public changeOrder (urldata: any): Observable<any> {

        const getOrderDetailsState: Observable<OrderDetailsState> = this.store.pipe(select(getorderDetailsState));

        return getOrderDetailsState.pipe(
            take(1)).pipe(
            flatMap((orderDetailsState: OrderDetailsState) => {

                const url: string = API_URLS.ORDER_DETAILS.CHANGE_ORDER;
                const selectedPositions: Position[] = [];

                let ordersToChange: Position[] = [];

                for (const key in orderDetailsState.changedPosition) {
                    // eslint-disable-next-line
                    if (orderDetailsState.changedPosition.hasOwnProperty(key)) {

                        /** cloning the positions to avoid any conflicts regarding deleting the articlesPerPosition from original one */
                        let tempPositions = cloneDeep(selectedPositions);
                        /** clean up the  unnecassary properties */
                        const customerType = orderDetailsState.delivery.mappedCustomerType;
                        tempPositions = this.cleanPositionsExtraDetails(orderDetailsState.changedPosition[key],  customerType);
                        if (tempPositions && tempPositions.length) {
                            for (const position of tempPositions) {
                                position.quantity = position.articlesPerPosition;
                                position.toGrossPrice = position.toGrossPrice && position.toGrossPrice.replace(',', '.');
                                position.returnFreeText = position.returnFreeText && position.returnFreeText.replace(this.semicolonCheck, ','),
                                delete position.articlesPerPosition;
                            }
                            ordersToChange = ordersToChange.concat(tempPositions);
                        }
                    }
                }
                const payload: any = {
                    client: CLIENT.ASP,
                    channel: orderDetailsState.delivery.channel,
                    orderLineItems: ordersToChange,
                };

                if (orderDetailsState.userCredentials.orderNumber) {
                    payload.orderId = orderDetailsState.userCredentials.orderNumber;
                }

                const headers: any = new HttpHeaders({ 'Content-Type': 'application/json' });
                const options = {headers: headers};

                return this.httpClient.put(url, payload, options).pipe(map((response) => {

                        return urldata;
                    }));
            }));
    }
    /**
     * Reduces and maps position arrays to { [key: string]: Position[] }
     */
    public reducePositionsArrayToObject (positions: Position[]): { [key: string]: Position[] } {
        return positions.reduce((acc, curr) => {
            return {
                ...acc,
                [curr.articleNumber]: [curr],
            };
        }, {}) as { [key: string]: Position[] };
    }
    /**
     * Map the position to the changed position
     * @param position position that will be filtered
     */
    public mapPositionsToChangedPosition (positions: { [key: string]: Position[] }): { [key: string]: Position[]; } {

        const changedPosition: { [key: string]: Position[]; } = {};

        for (const key in positions) {
            // eslint-disable-next-line
            if (positions.hasOwnProperty(key)) {

                changedPosition[key] = [<Position>(positions[key][0])];
            }
        }

        return changedPosition;
    }
    /**
     * flitering positions to get arrays of hardwares, sims and accessories
     * @param position position that will be filtered
     */
    public getAllHardwareSimAndAccessoriesDetails (position: { [key: string]: Position[]; }): {
        /** hardwareObjects */
        hardwareObjects: { [key: string]: Position[] },
        /** simObjects */
        simObjects: { [key: string]: Position[] },
        /** accessoriesObjects */
        accessoriesObjects: { [key: string]: Position[] },
    } {
        const allClassifiedPositions: {
            /** hardwareObjects */
            hardwareObjects: { [key: string]: Position[]; },
            /** simObjects  */
            simObjects: { [key: string]: Position[]; },
            /** accessoriesObjects */
            accessoriesObjects: { [key: string]: Position[]; },
        } = {
            hardwareObjects: {},
            simObjects: {},
            accessoriesObjects: {},
        };
        const simArticleNumberRegex = new RegExp(regex.simArticleNumber);
        const hardwareArticleNumberRegex = new RegExp(regex.hardwareArticleNumber);
        let articleNumberPositions: Position[] = null;

        for (const key in position) {
            // eslint-disable-next-line
            if (position.hasOwnProperty(key)) {
                articleNumberPositions = position[key];
                    if (simArticleNumberRegex.test(articleNumberPositions[0].articleNumber)) {

                        allClassifiedPositions.simObjects[key] = articleNumberPositions;
                    } else if (hardwareArticleNumberRegex.test(articleNumberPositions[0].articleNumber)) {
                        allClassifiedPositions.hardwareObjects[key] = articleNumberPositions;

                    } else {
                        allClassifiedPositions.accessoriesObjects[key] = articleNumberPositions;
                }
            }
        }

        return allClassifiedPositions;
    }
/** changePositionInGroupsToBeGroupedWithArticleNumber */
    public changePositionInGroupsToBeGroupedWithArticleNumber (groups: DeliveryGroupModel) {
        const groupedPositions = jsonpath.query(groups, JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.GET_ALL_POSTION_WITH_TIMESTAMP);
        const newGroups:  { [key: string]: Position[]; } = {};
        if (groupedPositions) {
            groupedPositions.forEach((pos) => {
                if (!newGroups[pos.articleNumber]) {
                  newGroups[pos.articleNumber] = [pos];

                } else {
                    newGroups[pos.articleNumber].push(pos);
                }

            });
        }

        return newGroups;
    }
/** checkOneElementPresent */
    public checkOneElementPresent (hardwareOrSimObjects: { [key: string]: Position[] }) {
        const arrayOfPositions = jsonpath.query(hardwareOrSimObjects, JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.FLATTEN_POSITION_IN_ARTICLENUMBER);

        return arrayOfPositions.length == 1;
    }
    /** filtering positons to accessories
     * @param positions
     */
     public getAccessoriesDetails (positions: {
        [key: string]: Position[] | Position;
      }): Position[] {
        const hardwareRegex = new RegExp(regex.hardwareArticleNumber);
        const simRegex = new RegExp(regex.simArticleNumber);

        return Object.values(positions)
          .map((item) => (Array.isArray(item) ? item[0] : item))
          .filter(
            (item) =>
              !hardwareRegex.test(item.articleNumber) &&
              !simRegex.test(item.articleNumber),
          );
      }
    /**
     * flitering positions to simonly and hardware
     * @param position position that will be filtered
     */
    // eslint-disable-next-line
    public getSimAndHardwareDetails (position: { [key: string]: Position[] | Position; }): {
       /** simOnlyObj */ simOnlyObj: Position,
       /** HardwareObj */  HardwareObj: Position,
    } {

        let simOnlyObj = null;

        let HardwareObj = null;

        const simNumberRegex = new RegExp(regex.simNumber);
        const hardwareArticleNumberRegex = new RegExp(regex.hardwareArticleNumber);
        let currentPosition: Position[] | Position = null;

        for (const key in position) {
            // eslint-disable-next-line
            if (position.hasOwnProperty(key)) {

                currentPosition = position[key];

                if (Array.isArray(currentPosition)) {

                    if (simNumberRegex.test(currentPosition[0].articleNumber)) {

                        simOnlyObj = currentPosition[0];
                    } else {

                        HardwareObj = currentPosition[0];
                    }

                } else {

                    if (simNumberRegex.test(currentPosition.articleNumber)) {

                        simOnlyObj = currentPosition;
                    } else {

                        HardwareObj = currentPosition;
                    }
                }
            }
        }

        const positionKeys = Object.keys(position);
        if (positionKeys.length > 2) {
            for (let i = 0; i < positionKeys.length; i++) {
                /** if the postions contains starter position then select the postiion with articleNo starts with 3 */
                const currPosition = position[positionKeys[i]];
                if (!simNumberRegex.test(currPosition[0].articleNumber) && currPosition[0].articleNumber.startsWith('3')) {
                    HardwareObj = currPosition[0];
                }
            }
        }

        return { simOnlyObj, HardwareObj };
    }
    /**
     * cleanPositionsExtraDetails
     * @param positions Position[]
     * @return the new positions
     */
    public cleanPositionsExtraDetails (positions: Position[], customerType): Position[] {
        const newPositions: Position[] = [];
        const propsToBeCleaned: string[] = PROPERTIES_TO_BE_CLEANED;
        customerType === CustomerTypes.NeoTiger ? propsToBeCleaned.push('articleNumber') : '';

        for (const pos of positions) {
            newPositions.push(omit(pos, propsToBeCleaned));
        }

        return newPositions;
    }

    /**
     * get data after sumbit user credentials
     * @param {UserCredentials} userCredentials
     */
    public getMappedOrderDetails (userCredentials: UserCredentials) {
        return this.getOrderDetails(userCredentials).pipe(flatMap((response) => {
                return this.mapOrderDetails(response);
            }), catchError((reason) => {
                return throwError(reason);
            }));
    }

    /**
     * returning  the current customer type
     */

    /** getCutomerType */
    public getCutomerType () {

        this.store.select(selectCustomerType).pipe(takeUntil(this.ngUnsubscribe)).subscribe((currentCustomerType) => {
            if (currentCustomerType) {
                this.customerType = currentCustomerType;

                return this.customerType;
            }
        });
    }

    /**
     * get order details data
     * @param {UserCredentials} userCredentials
     */
    public getOrderDetails (userCredentials: UserCredentials) {
        const url = API_URLS.LOGIN.GET;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let params;
        if (userCredentials) {
            params = {
                'client': LOGIN_QUERYPARAMS.ASP,
                'request-id': userCredentials.deliveryNumber,
                'post-code': userCredentials.zipCode,
            };
            if (userCredentials.orderNumber) {
                params['order-id'] = userCredentials.orderNumber;
            }
        }

        const options = { headers: headers, params: params };

        return this.httpClient.get(url, options).pipe(map(response => {
            return response;
        }), catchError((reason) => {
            try {
                const errorJson = reason;
                const status = reason.status;
                const errorCode = errorJson.error.faultMessage.code;
                this.customError.getErrorDescription(MODULE_NAMES.LOGIN, errorCode, status, true, true);

                return throwError(reason);
            } catch { }
        }));
    }

    /** get images from vluxgate if exist and if not get it  from default images in cms
     * @param imageLink return imagelink if exist in the response
     * @param articleNumber the article number of the device image from vluxgate
     */
    public getImageFromVlux (imageLink, articleNumber): Observable<string> {

        if (imageLink) {

            return of(imageLink);

        } else {
            const url = API_URLS.LOGIN.GET_IMAGES_FROM_VLUX.replace('{articleNumber}', articleNumber);
            const headers = new Headers({ 'Content-Type': 'application/json' });

            return this.httpClient.get(url).pipe(map((resp: any): string => {

                const response = resp;

                return response.value;
            }), catchError((reason) => {
                if (this.customerType) {

                    if (this.customerType === CustomerTypes.Rabbit) {

                        return of(this.ts.instant('common.links.vluxImages.types.accessory.link-href'));
                    } else if (this.customerType === CustomerTypes.Python || this.customerType === CustomerTypes.Cobra) {
                        return of(this.ts.instant('common.links.vluxImages.types.dsl.link-href'));

                    } else if (this.customerType === CustomerTypes.Polarbear) {
                        return of(this.ts.instant('common.links.vluxImages.types.giga_cube.link-href'));

                    } else {
                        return of(this.ts.instant('common.links.vluxImages.types.phones.link-href'));

                    }
                }

            }));
        }
    }

    /**
     * map order details state with data from response
     * @param response contain order details data and tariff mobile constant file
     */
    public mapOrderDetails (response): Observable<Delivery> {
        this.secondDeliveryAllowed = false;
        const orderDetails = response;
        const positionsAndGroup: {
          // eslint-disable-next-line no-use-before-define
          /**
           * positions
           * */  positions: { [key: string]: Position[] },
            // eslint-disable-next-line
        /** groups */ groups: { [key: string]: { [key: string]: {
            /** position */
            position: Position,
            /** quantity */
            quantity: number }[] } },
        } = null;

        return this.getTariffName(orderDetails.tariffCode).pipe(
            flatMap((responseJson) => {

                let isPostalShopping: boolean = false;

                const customerData = {
                    channel: orderDetails.channel,
                    customerType: orderDetails.customerType,
                    isEnterprise: orderDetails.isEnterprise,
                };
                const postShoppingActionNumbers: number[] = this.ts.instant('common.postalShopping.actionNumbers');

                if (Array.isArray(postShoppingActionNumbers) && orderDetails.actionNumber) {

                    isPostalShopping = !!(postShoppingActionNumbers.map(v => v['std-headline']).includes(orderDetails.actionNumber.toString()));
                }

                const delivery = {
                    tariffCode: orderDetails.tariffCode,
                    tariffName: (responseJson && responseJson['tariffName']) || '',
                    logistics: this.setLogistics(orderDetails),
                    channel: orderDetails.channel,
                    customerType: orderDetails.customerType,
                    orderDate: orderDetails.orderDate,
                    shipToContactPoint: this.setShipToContactPoint(orderDetails),
                    shipToParty: this.setShipToParty(orderDetails),
                    secondDeliveryAllowed: this.secondDeliveryAllowed,
                    shipmentNumber: orderDetails.shipmentNumber,
                    status: this.mapOrderStatus(orderDetails),
                    salesOrganization: orderDetails.salesOrganization,
                    customerStatus: orderDetails.customerStatus,
                    salesChannel: orderDetails.salesChannel,
                    isEnterprise: orderDetails.isEnterprise,
                    emailAddress: jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.EMAIL),
                    salesOrderType: orderDetails.salesOrderType,
                    senderParty: orderDetails.shipToParty,
                    senderContactPoints: orderDetails.shipToContactPoints,
                    isPostalShopping,
                } as Delivery;

                delivery.mappedCustomerType = this.mapCustomerType(customerData, delivery);
                this.customerType = delivery.mappedCustomerType;

                return this.setPositionsAndGroup(orderDetails).pipe(
                    map((positionsAndGroup) => {

                        delivery.positions = positionsAndGroup.positions;
                        delivery.groups = positionsAndGroup.groups;

                        return delivery;
                    }));
            }));
    }

   /** mapOrderStatus
    * map order status maps delivery status according to position number returned in logistics
    * in case that there are previous transactions with transaction name 'revoke ... ' or 'defect-return' and no forwardToAgent is set
    * then the delivery status is return requested
    * @param orderDetails order details object
    */
    public mapOrderStatus (orderDetails) {
        let position;
        const previousElement = jsonpath.value(orderDetails, JSON_PATHS.NIL.LOGIN_AFTER_SUCCESS.MAP_PREVIOUS_TRANSACTION);
        const element = previousElement && previousElement.find(previous => {
            // eslint-disable-next-line
            return ((previous.transactionName.indexOf(LOGIN_SUCCESS.DELIVERY_STATUS.REVOKE) != -1 || previous.transactionName === TRANSACTION_NAMES.DEFECT_RETURN) && !previous.hasOwnProperty(LOGIN_SUCCESS.DELIVERY_STATUS.FORWARD_TO_AGENT));
        });
        if (element) {
            position = 0;
        } else {
            const positionMapped = jsonpath.value(orderDetails, JSON_PATHS.NIL.LOGIN_AFTER_SUCCESS.MAP_DELIVERY_STATUS);

            position = positionMapped;
        }

        return DeliveryStatus['_' + position];
    }
    /**
     * setLogistics sets object logistics in delivery
     * @param orderDetails
     */
    public setLogistics (orderDetails) {
        return {
            trackingLink: jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.TRACKING_LINK),
            trackingNumber: jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.TRACKING_NUMBER),
            position: jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.POSITION),
        } as Logistics;
    }
    /**
     * get user friendly tariff name
     * @param tariffCode order details tariff code
     */
    public getTariffName (tariffCode) {

        const url = API_URLS.LOGIN.GET_TARIFF_NAME.replace('{tarifCode}', tariffCode);
         if (!tariffCode) {

            return of(null);
        }

        return this.httpClient.get(url).pipe(map(response => {

            return response;
        }));
    }

    /**
     * set positions to fill order details state
     * @param orderDetails contains data nedded to get position
     * getImage for the divces from vlux or cms if it is not exist in the response
     */
                // eslint-disable-next-line
    public setPositionsAndGroup (orderDetails): Observable<{
        /** positions */
        positions: { [key: string]:
            /** postion */
            Position[] },
        /** groups */
        groups: { [key: string]: { [key: string]: {
            /** position */
            position: Position,
            /** quantity */
            quantity: number }[] } },
    }> {

        const positions: { [key: string]: Position[] } = {};
                // eslint-disable-next-line
        const groups: { [key: string]: { [key: string]: {
            /** position */
            position: Position,
            /** quantity */
            quantity: number }[] } } = {};

        let positionStatus: PositionStatus = null;

        const imagesObservables: Observable<void>[] = [];
        orderDetails && forEach(orderDetails.orderLineItems, (pos) => {
            const position: Position = {
                orderPosition: pos.orderPosition,
                articlesPerPosition: pos.articlesPerPosition,
                imei: pos.imei,
                articleName: pos.articleName,
                articleNumber: pos.articleNumber,
                msisdn: pos.msisdn,
                simNumber: pos.simNumber,
                returnsEntitled: pos.returnsEntitled,
                productGroup: pos.productGroup,
                orderId: pos.orderId,
                lastAcceptedDate: pos.lastAcceptedDate,
                secondDeliveryAllowed: pos.secondDeliveryAllowed,
                scheduledDeliveryDate: pos.scheduledDeliveryDate,
                deliveryDate: pos.deliveryDate,
                imageLink: null,
                simFormat: this.mapSimType(),
                positionClassification: this.utilsService.classifyPosition(pos),
                ...pos,
            } as Position;
            if (!isEmpty(pos.esims)) {
                position.esims = this.setEsimData(pos);
                this.customerType === CustomerTypes.NeoTiger ?
                (position.articleNumber = position.esims[0].serialNumber) &&
                 (pos.articleNumber = position.esims[0].serialNumber ) : '';
            }

            pos.simFormat = this.mapSimType();
            let hardwareObj = this.getSimAndHardwareDetails({ [pos.articleNumber]: [pos] }).HardwareObj;

            this.secondDeliveryAllowed = pos.secondDeliveryAllowed ? true : this.secondDeliveryAllowed;
            if (pos.previousTransactions && pos.previousTransactions.length) {

                position.previousTransactions = pos.previousTransactions.map((previousTransaction: PerviousTransaction, index: number): PerviousTransaction => {

                    previousTransaction.timestamp = new Date(previousTransaction.timestamp).getTime().toString();

                    return previousTransaction;
                });

                positionStatus = this.updateGroupAndPosition(position, groups);
                /** update delivery articlePerPositions */
                pos.articlesPerPosition = position.articlesPerPosition;
                if (positionStatus === PositionStatus.ADD) {

                    positions[pos.articleNumber] = positions[pos.articleNumber] || [];

                    positions[pos.articleNumber].push(pos);
                }
            } else {

                positions[pos.articleNumber] = positions[pos.articleNumber] || [];

                positions[pos.articleNumber].push(pos);
            }

            hardwareObj = this.getSimAndHardwareDetails({ [pos.articleNumber]: [pos] }).HardwareObj;

            if (hardwareObj) {

                imagesObservables.push(this.getImageFromVlux(hardwareObj.imageLink, hardwareObj.articleNumber).pipe(
                    map((image: string) => {

                        pos.imageLink = image;

                        position.imageLink = pos.imageLink;

                        try {

                            let query: string = `@.articleNumber=="${position.articleNumber}"`;

                            if (position.imei) {

                                query += `&& @.imei=="${position.imei}"`;
                            }
                            query = `$..[?(${query})].imageLink`;

                            jsonpath.apply(groups, query, () => pos.imageLink);
                        } catch (error) {
                        }
                    })));
            }
        });

        if (imagesObservables.length > 0) {
            return forkJoin(imagesObservables).pipe(
                map((data) => {
                    return {
                        positions,
                        groups,
                    };
                }));
        } else {
            return of({
                positions,
                groups,
            });
        }
    }

    /**
     * Update the groups and the position
     * @param Position contains data nedded to get position
     * @param groups groups to be modified
     * @returns PositionStatus whether to update or delete the position
     */
    public updateGroupAndPosition (position: Position, groups: DeliveryGroupModel): PositionStatus {

        let newPosition: Position = null;

        let deliveryArticlesPerPosition: number = position.articlesPerPosition;

        let transactionNumber: number = 0;

        position.previousTransactions.forEach((previousTransaction: PerviousTransaction) => {

            const incrementQuantity = previousTransaction.quantity || 1;

            if (!previousTransaction.forwardToAgent && position.articlesPerPosition > 0) {

                if (groups[previousTransaction.timestamp] && groups[previousTransaction.timestamp][previousTransaction.transactionName]) {

                    transactionNumber = this.getTransaction(groups, position, previousTransaction);

                    if (transactionNumber >= 0) {

                        groups[previousTransaction.timestamp][previousTransaction.transactionName][transactionNumber].quantity
                            += incrementQuantity;
                    } else {

                        newPosition = cloneDeep(this.updatePositionWithReasonCodes(position, previousTransaction));

                        newPosition.articlesPerPosition = incrementQuantity;

                        groups[previousTransaction.timestamp][previousTransaction.transactionName].push({
                            position: newPosition,
                            quantity: incrementQuantity,
                        });
                    }
                } else {

                    groups[previousTransaction.timestamp] = groups[previousTransaction.timestamp] || {};

                    newPosition = cloneDeep(this.updatePositionWithReasonCodes(position, previousTransaction));

                    newPosition.articlesPerPosition = incrementQuantity;

                    groups[previousTransaction.timestamp][previousTransaction.transactionName] = [{
                        position: newPosition,
                        quantity: incrementQuantity,
                    }];
                }

                if (deliveryArticlesPerPosition > 0) {

                    deliveryArticlesPerPosition -= incrementQuantity;
                }
            }
        });

        if (deliveryArticlesPerPosition > 0) {

            position.articlesPerPosition = deliveryArticlesPerPosition;

            return PositionStatus.ADD;
        }

        return PositionStatus.DELETE;
    }

    private getTransaction (groups: DeliveryGroupModel, position: Position, previousTransaction: PerviousTransaction): number {

        const groupTransactions = groups[previousTransaction.timestamp][previousTransaction.transactionName];

// eslint-disable-next-line
        return findIndex(groupTransactions, (
            /** groupTransaction */
            groupTransaction: {
            /** position */
            position: Position,
            /** quantity */
            quantity: number }) => {

            if (position.imei) {

                return groupTransaction.position.articleNumber === position.articleNumber && groupTransaction.position.imei === position.imei;
            } else if (position.simNumber) {

                return groupTransaction.position.articleNumber === position.articleNumber && groupTransaction.position.simNumber === position.simNumber;
            } else {

                return groupTransaction.position.articleNumber === position.articleNumber;
            }
        });
    }

    /**
     * set shipToContactPoint to fill order details state
     * @param orderDetails contains data nedded to get shipContactPoint
     */
    public setShipToContactPoint (orderDetails) {
        const postal = jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.POSTAL) || jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.POSTALBILL);
        const shipToContactPoint: ShipToContactPoint = {
            city: postal.city,
            countryCode: postal.countryCode,
            streetHouseNumber: postal.streetHouseNr,
            postCode: postal.postCode,
        } as ShipToContactPoint;

        return shipToContactPoint;
    }
    /**
     * map customer type to his user role
     * @param customerData
     */
    public mapCustomerType (customerData, delivery: Delivery) {
        let combinedData = (customerData.channel ? customerData.channel + '-' : '') + (customerData.customerType ? customerData.customerType : '') + (customerData.isEnterprise ? '-' + ENTERPRISE : '');
        combinedData = combinedData.endsWith('-') ? combinedData.substring(0, combinedData.length - 1) : combinedData;
        combinedData = combinedData ? combinedData.toUpperCase() : '';
        let customerType = USER_TYPES.MAPPED_CUSTOMER_TYPE[combinedData];
        customerType = ELIGIBLE_USER_SECOND_DELIVERY.indexOf(customerType) > -1 && Number(delivery.logistics.position) === 7 ? USER_TYPES.MAPPED_CUSTOMER_TYPE[combinedData + '-' + SECOND_DELIVERY.SECOND] : customerType;

            return customerType;
    }

    /**
     * set shipToParty to fill order details state
     * @param orderDetails contains data nedded to get shipToParty
     */
    public setShipToParty (orderDetails) {
        const individual = jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.INDIVIDUAL) || jsonpath.value(orderDetails, JSON_PATHS.NIL.ORDER_DETAILS.INDIVIDUALBILL);
        const shipToParty: ShipToParty = {
            additionalName1: individual.additionalName1,
            additionalName2: individual.additionalName2,
            salutationName: individual.salutation,
            legalName: individual.legalName,
        } as ShipToParty;

        return shipToParty;
    }

    /** updatePositionWithReasonCodes
     * update the position with the reason codes in case of it was reported as defect
     * @param position position to be updated
     * @param previousTransaction to update the position reasonCodes
     */
    public updatePositionWithReasonCodes (position: Position, previousTransaction: PerviousTransaction): Position {

        if (previousTransaction.transactionName === TRANSACTION_NAMES.DEFECT_RETURN) {
            position.returnReasonCode = previousTransaction.returnReasonCode;
            position.returnReasonText = previousTransaction.returnReasonText;
            position.returnFreeText = previousTransaction.returnFreeText;
        } else if (previousTransaction.returnReasonCode) {
            position.returnReasonCode = previousTransaction.returnReasonCode;
        }

        return position;
    }
    /**
     * set esim data for position
     * @param {Position} position
     */
    public setEsimData (position) {
        const esims: Array<EsimModel> = [];
        position.esims && position.esims.forEach((esim) => {
            const esimModel: EsimModel = {
                serialNumber: esim.serialNumber,
                ultraCardSlot: esim.ultraCardSlot,
                activationCode: esim.ultraCardSlot,
                eid: esim.eid,
                esimStatus: esim.esimStatus,
                isInstalled: esim.isInstalled,
                confirmationCode: esim.confirmationCode,
                oldSim: esim.oldSim,
                simStatus: esim.simStatus,
                positionClassification: PositionClassification.isEsim,
            };
            esims.push(esimModel);
        });

        return esims;
    }

    /**
     * check sim type physical or esim
     */
    public mapSimType () {

        return MAPPED_SIM_TYPE[this.customerType];
    }
    /**
     * to return the status of gigacube user with postal shopping
     * to check if there is one or more gigacube device/s
     * And to check the revokation period and the happiness guarantee
     */
     public  getStatusForGigacubePostalShopping ( hardwareObjectsPositions , hardwareObjectsGroups): Observable <any> {
        const isOnlyOneHardWare = this.checkIfOneHardWareOnly (hardwareObjectsPositions , hardwareObjectsGroups);

        return this.checkReturnsEnTitled().pipe(map((returnsEntitled) => {
            if ( isOnlyOneHardWare == true && returnsEntitled == true ) {
                return PostalShoppingScenarios.singleWithRevocationPeriodGigaCube ;
            } else if ( isOnlyOneHardWare == false && returnsEntitled == true ) {
                return PostalShoppingScenarios.moreThanOneDeviceWithRevocationPeriodGigaCube;
            } else {
                return PostalShoppingScenarios.RevocationPeriodExpaired ;
            }
        }));

    }
    /** check the length of hardware devices */
    public checkIfOneHardWareOnly (hardwareObjectsPositions, hardwareObjectsGroups) {
        return ( hardwareObjectsGroups.length +  hardwareObjectsPositions.length) == 1;
    }
    /** check the ReturnsEntitled */
    public checkReturnsEnTitled () {
      return  this.store.select(getLogisticsPositionAndReturnsEntitled).pipe(take(1), map((value: Position)  => {
           return value.returnsEntitled == ReturnsEntitled.W || value.returnsEntitled == ReturnsEntitled.Z ;
        }));

    }
    /** set the selected postal shopping positions */
    public setPostalShoppingPostions ( initialHW?, initialSim?, initialAccessory?, noAccessoriesExsit?, groupsKeys? ) {
        const currentPositions = [];
        if (initialHW.length > 0 ) {
            initialHW.forEach(hardware => {
                currentPositions.push(hardware) ;
            });
            if ((initialSim.length == 1 || ( initialSim.length > 0 && (noAccessoriesExsit == true || groupsKeys.length)))) {
                initialSim.forEach(sim => {
                    currentPositions.push(sim) ;
                });
            }
        }
        if (initialAccessory.length > 0) {
            initialAccessory.forEach(accessory => {
                currentPositions.push(accessory) ;
            });
            if (((initialSim.length > 1) && noAccessoriesExsit == false) || ((initialSim.length >= 1) && noAccessoriesExsit == false && groupsKeys.length)) {
                initialSim.forEach(sim => {
                    currentPositions.push(sim) ;
                });
            }
        }
        this.updatePostions(currentPositions, true);
    }
    /**
     * positions holds the position that will be dispatched in UpdatePosition as a selected position
     * @param pos {Position}
     */
    public updatePostions (pos?, isPostalShopping?: boolean) {
        const positions: { [key: string]: Position[] } = {};
        pos.forEach(element => {
            positions[element.articleNumber] = [element];
        });
        if (isPostalShopping) {
            this.store.dispatch(new SetPostalShoppingCustomPositions({
                positions: positions,
            }));
        } else {
            this.store.dispatch(new UpdatePosition({
                changedPosition: positions,
            }));
        }
    }
    /**
     * positions holds the position that will be dispatched in UpdatePosition as a selected position
     * @param pos {Position}
     */
    public updatePostionsConfirmation (pos?) {
        const positions: { [key: string]: Position[] } = {};
        pos.forEach(element => {
            positions[element.position.articleNumber] = [element.position];
        });
        this.store.dispatch(new UpdatePosition({
            changedPosition: positions,
        }));
    }

    /**
     * return current postal shopping positions
     */
    public getPostalShoppingPostions () {
       return this.store.select(getPostalShoppingCustomPositions).pipe(map ( positions => {
           return  positions ;
        }));
    }

    /**
     * return isPostalShopping
     */
    public isPostalShopping () {
       return this.store.select(getPostalShopping).pipe((map) ( value => {
           return value ;
       }));
    }

    /**
     * populate transaction names
     */
    public populateTransactionNames (positions) {

        const simArticleNumberRegex = new RegExp(regex.simArticleNumber);

        const hardwareArticleNumberRegex = new RegExp(regex.hardwareArticleNumber);

        forOwn(positions, (value, key) => {

                value.forEach(position => {

                    if (simArticleNumberRegex.test(position.articleNumber)
                    || hardwareArticleNumberRegex.test(position.articleNumber)) {

                        this.store.dispatch(
                            new SetTransactionName({
                                transactionName: TRANSACTION_NAMES.REVOKE_CONTRACT_WITH_HW,
                                articleNumber: position.articleNumber,
                            }),
                        );
                    } else {

                        this.store.dispatch(
                            new SetTransactionName({
                                transactionName: TRANSACTION_NAMES.REVOKE_ACCESSORIES,
                                articleNumber: position.articleNumber,
                            }),
                        );
                    }
            });
        });
    }
}
